module.exports = "/_next/static/pages/test-guidelines/61bed5427981ed72b5be0b2e5933241d.png";